import React from 'react';

import EntityPathNamesValue from 'components/EntityPathNamesValue';

// @ts-ignore
import FormTimesheetEntryValue from '../FormTimesheetEntryValue';
// @ts-ignore
import EntityTableCellRenderDropdown from '../EntityTableCellRenderDropdown';
import SelectableTableCell from '../SelectableTableCell';

interface Props {
    rowId: number;
}

export class EntityFieldValueComponent extends React.PureComponent<Props> {
    render(): React.ReactElement | string | null {
        const { rowId } = this.props;

        return (
            <FormTimesheetEntryValue
                rowId={rowId}
                cellName="workTypeCompositeKey"
            >
                {(workTypeCompositeKey: any): React.ReactElement => {
                    const [, , entityTypeIdString]: any = workTypeCompositeKey
                        ? workTypeCompositeKey.split('.')
                        : [];
                    const entityTypeId = Number(entityTypeIdString);
                    return (
                        <SelectableTableCell
                            rowId={rowId}
                            cellName="entityCompositeKey"
                            component={EntityTableCellRenderDropdown}
                            entityTypeId={entityTypeId}
                        >
                            {(entityCompositeKey: any): React.ReactElement => {
                                const [entityIdString]: any = entityCompositeKey
                                    ? entityCompositeKey.split('.')
                                    : [];
                                const entityId = Number(entityIdString);
                                return (
                                    <EntityPathNamesValue entityId={entityId} />
                                );
                            }}
                        </SelectableTableCell>
                    );
                }}
            </FormTimesheetEntryValue>
        );
    }
}

export default EntityFieldValueComponent;
